import Vue from "vue"
import { showGlobalMessage, getDeliveryMethod } from "@/utils/utils"

export const MAX_VALUE = 99

export const isChecked = (item = {}) => {
  return item.checked === 1
}
export const soldOut = (item = {}) => {
  return item.wareStatus && item.wareStatus.invalidWareFlag === 1
}
// 自提模式 && abnormalState === 4
export const deliveryOnly = (item = {}) => {
  return getDeliveryMethod() === "clickCollect" && item.wareStatus && item.wareStatus.abnormalState === 4
}
export const getMax = (item = {}) => {
  if (!item.remainingStock) return MAX_VALUE

  if (item.remainingStock > MAX_VALUE) {
    return MAX_VALUE
  }
  return item.remainingStock
}
export const fen2Yuan = num => {
  if (isNaN(num)) return ""
  num = Number(num)
  return (num / 100).toFixed(2)
}
export const getNumber = nums => {
  const num = fen2Yuan(nums)
  const str = num.toString()
  const res = str.split(".")
  return res[0]
}
export const getSmallNumber = nums => {
  const num = fen2Yuan(nums)
  const str = num.toString()
  const res = str.split(".")
  return res.length === 2 ? res[1] : ""
}

export const showMessage = (message = "", subMessage = "") => {
  Vue.nextTick(() => {
    const headerEl = document.getElementById("top-box")
    const headerHeight = (headerEl && headerEl.clientHeight) || 0
    const gap = 16
    showGlobalMessage({
      message,
      subMessage,
      gap: headerHeight + gap,
      iconClass: "messageWarning"
    })
  })
}

// 获取围栏内主门店
export const getRangeStore = data => {
  // 围栏内数据(storeGroupType === 'Range')
  const rangeStoreGroup = (data.storeGroupList || []).find(item => item.storeGroupType === "Range") || {}
  const store = (rangeStoreGroup.storeList && rangeStoreGroup.storeList[0]) || {}

  return store
}

// 获取围栏内从门店列表
export const getRangeSlaveStoreList = data => {
  // 围栏内数据(storeGroupType === 'Range')
  const rangeStoreGroup = (data.storeGroupList || []).find(item => item.storeGroupType === "Range") || {}
  const slaveStoreList = rangeStoreGroup.otherStoreList || []

  return slaveStoreList
}

export const getItemGroup = (type, store = {}) => {
  const itemGroupList = store.itemGroupList || []
  return itemGroupList.find(item => item.itemGroupType === type) || {}
}

export const getWareItems = (type, store) => {
  const result = getItemGroup(type, store)
  return result.itemList || []
}

// bestOffer中会有重复的sku
// 根据sku去重
export const getUniqWares = items => {
  const allWares = []
  items.forEach(item => {
    item.wareList.forEach(subItem => {
      allWares.push({
        sku: subItem.skuId,
        skuId: subItem.skuId,
        count: subItem.count,
        stock: subItem.remainingStock
      })
    })
  })

  const tempObj = {}
  allWares.forEach(item => {
    const skuId = item.skuId
    if (!(skuId in tempObj)) {
      tempObj[skuId] = item
    } else {
      tempObj[skuId].count += item.count
    }
  })

  return Object.values(tempObj)
}
